import { useEffect, useState } from "react";
import { loadCareerTrends } from "../http/fetch-status";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar, Scatter } from "react-chartjs-2";
import { HiAnnotation } from "react-icons/hi";

const CareerTrends = () => {
  const [xAxis, setXAxis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [career, setCareer] = useState(null);
  const [metric, setMetric] = useState("kd");

  const [datasets, setDatasets] = useState([]);
  const [datasetsB, setDatasetsB] = useState([]);

  const careers = new Map([
    [null, "Select a career"],
    ["CHOPPA", "Choppa", "rgb(255, 99, 132)"],
    ["SLAYER", "Slayer", "rgb(255, 159, 64)"],
    ["WHITE_LION", "White Lion", "rgb(255, 205, 86)"],
    ["SHADOW_WARRIOR", "Shadow Warrior", "rgb(75, 192, 192)"],
    ["SQUIG_HERDER", "Squig Herder"],
    ["MARAUDER", "Marauder"],
    ["BRIGHT_WIZARD", "Bright Wizard"],
    ["SORCERER", "Sorcerer"],
    ["ENGINEER", "Engineer"],
    ["MAGUS", "Magus"],
    ["WITCH_HUNTER", "Witch Hunter"],
    ["WITCH_ELF", "Witch Elf"],
    ["ORDER_DPS", "Order (DPS)"],
    ["DESTRO_DPS", "Destruction (DPS)"],
  ]);

  const [loadedCareers, setLoadedCareers] = useState([]);

  useEffect(() => {
    if (career == null) {
      setLoading(false);
      return;
    }

    setLoading(true);
    if (loadedCareers.includes(career)) {
      setLoading(false);
      return;
    }

    loadCareerTrends({ career })
      .then((response) => {
        setLoadedCareers([...loadedCareers, career]);

        if (xAxis.length == 0) {
          setXAxis(response.data.map((week) => week.week));
        }

        const careerColors = new Map([
          // Choppa green          ,
          ["CHOPPA", "rgb(75, 192, 192)"],
          // Squig Herder dark green
          ["SQUIG_HERDER", "rgb(0, 128, 0)"],
          // Slayer orange
          ["SLAYER", "rgb(255, 159, 64)"],
          // White Lion blue
          ["WHITE_LION", "rgb(50, 55, 205)"],
          // shadow warrior light blue
          ["SHADOW_WARRIOR", "rgb(0, 255, 255)"],
          // Marauder grey
          ["MARAUDER", "rgb(128, 128, 128)"],
          // Bright Wizard yellow
          ["BRIGHT_WIZARD", "rgb(220, 80, 60)"],
          // Sorceress purple
          ["SORCERER", "rgb(128, 0, 128)"],
          // Engineer yellow
          ["ENGINEER", "rgb(255, 255, 0)"],
          // Magus Silver
          ["MAGUS", "rgb(192, 192, 192)"],
          // Witch Hunter
          ["WITCH_HUNTER", "rgb(255, 0, 0)"],
          // Witch Elf
          ["WITCH_ELF", "rgb(255, 0, 255)"],
          // Order blue
          ["ORDER_DPS", "rgb(14, 165, 233)"],
          // Destro red
          ["DESTRO_DPS", "rgb(239, 68, 68)"],
        ]);

        const newDataSet = {
          label: careers.get(career),
          type: "line",
          data: response.data.map((week) => week.kd),
          borderWidth: 2,
          fill: false,
          borderColor: careerColors.get(career),
        };

        const newDataSetB = {
          label: careers.get(career),
          type: "line",
          data: response.data.map((week) => week.kda),
          borderWidth: 2,
          fill: false,
          borderColor: careerColors.get(career),
        };

        setDatasets([...datasets, newDataSet]);
        setDatasetsB([...datasetsB, newDataSetB]);

        //console.log(datasets);
        //console.log(xAxis);

        setLoading(false);
      })
      .catch((error) => {
        setError(true);
        setLoading(false);
      });
  }, [career]);

  const options = {
    responsive: true,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        //max: 6,
      },
    },
  };

  // add a vertical line at week 2023.49 to options
  options.plugins = {
    annotation: {
      annotations: {
        line1: {
          type: "line",
          mode: "vertical",
          scaleID: "x",
          value: 2023.49,
          borderColor: "red",
          borderWidth: 2,
          label: {
            content: "2023.49",
            enabled: true,
            position: "top",
          },
        },
      },
    },
  };

  return (
    <div>
      <div className="grid grid-cols-4 gap-2 my-5">
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">CAREER</label>
          <select onChange={(e) => setCareer(e.target.value)} value={career}>
            {[...careers].map((i) => {
              return <option value={i[0]}>{i[1]}</option>;
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">MEASURE</label>
          <select onChange={(e) => setMetric(e.target.value)} value={metric}>
            <option value={"kd"}>{"KD"}</option>
            <option value={"kda"}>{"KDA"}</option>
          </select>
        </div>
      </div>
      <div className="text text-gray-500">
        This chart shows the RvR Kill to Death ratio (KD) for the seleceted
        class from week to week. It is calculated by getting all the total kills
        and deaths during EU Prime RvR for all characters each week who played
        the class.{" "}
      </div>
      <div className="flex flex-col space-y-2">
        {loading && <p>Loading...</p>}
        {error && <p>There was an error</p>}
      </div>
      {!loading && xAxis.length > 0 && (
        <>
          <div>
            <Line
              data={{
                labels: xAxis,
                datasets: metric == "kd" ? datasets : datasetsB,
              }}
              options={options}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CareerTrends;
